// comes from FreightBillingStatus in queries-processed
export enum EBillingStatus {
  NON_BILLABLE = 'NON_BILLABLE',
  READY_TO_INVOICE = 'READY_TO_INVOICE',
  INVOICED = 'INVOICED',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
}
